import * as React from "react"
import Privacy from "../components/Privacy/Privacy"

const PrivacyPage  = () => (
  <Privacy />
)


export default PrivacyPage